import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './PlanScorecardCompanyLetter.css'

@CSSModules(Styles, {allowMultiple: true})
export default class VanguardCompanyLetter extends Component {
  static propTypes = {
    differentPage: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      differentPage: this.props.differentPage || false
    }
  }

  render() {
    //
    return (
      <blockquote styleName='company-letter-blockquote'>
        <p><b>To: Vanguard</b></p>
        <p><b>From: <i>As You Sow</i> & Concerned Amazon Employees</b></p>

        <p>Dear Fund Manager,</p>

        <p>Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber, and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts, and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and corporate 401(k) clients like myself to a host of material risks.</p>

        <p>Critically, the default 401(k) option for Amazon employees is not invested sustainably. Over 50% of assets invested in the plan are in the default option target date funds from Vanguard. Because these funds are not invested sustainably, millions of dollars in employee savings are being allocated to deforestation-risk investments.</p>

        <p>Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Vanguard needs to do the same. It is both a moral and an economic imperative. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios, including my 401(k) default option at Amazon.</p>

        <p>Thank you.</p>

      </blockquote>
    )
  }
}
